import React from 'react';
import Layout from '../../components/Layout';
import WhyHostNew from './WhyHostNew';
import messages from '../../locale/messages';
import { getBatch2PageSeo } from '../../helpers/routeSeo';

let becomeHeaderCss = 'becomeHeaderCss';

export default async function action({ store }) {
  const { title, description } = getBatch2PageSeo(
    store,
    messages.batch2WhyHostMetaTitle,
    messages.batch2WhyHostMetaDescription,
  );
  return {
    title,
    description,
    component: (
      <Layout becomeHeader={true} becomeHeaderCss={becomeHeaderCss}>
        <WhyHostNew title={title} />
      </Layout>
    ),
  };
};
